export const TABLES = {
  APPLICATIONS: 'applications',
  APPLICATION_HISTORY: 'application_history',
  COMPANIES: 'companies',
  CLIENTS: 'users',
  USERS: 'users',
  ADVISORS: 'advisors',
  COMPANY_ADMINS: 'company_admins',
  DOCUMENTS: 'documents',
  COMMENTS: 'comments',
  MESSAGES: 'messages',
} as const; 